import React, { createContext, useCallback, useState, useContext, useEffect } from 'react';
import api from '../services/api';
import { authTitle, hash } from '../config';
import { useSocket } from './Socket';
import { useAuth } from './Auth';
import { usePages } from './Pages';
import { loadFromJson } from 'src/utils/loadFromJson';


interface ConfigurationState {
  token: string;
  user: Record<string, any>;
}

interface IOption {
  type: string;
  id: string;
  subtype: string;
  value: string;
}

interface ISignInAdmin {
  email: string;
  password?: string;
}

interface IConfiguration {
  _id?: string;
  title?: string;
  url?: string;
  color?: string;
  program_title?: string;
  program_subtitle?: string;
  logo?: string;
  logo_adicional?: string;
  upper_text?: string;
  header_image?: string;
  data_image?: string;
  lower_text?: string;
  next_date?: Date;
  header_video?: string;
  fixed_image_header?: string;
  background?: string;
  background_color?: string;
  certificates?: string;
  theme_data?: Record<string, any>;
  current_event_id_response?: Record<string, any>;
  active_pages?: Array<Record<string, any>>;
  allow_pix?: string;
  allow_boleto?: string;
  allow_credit_card?: string;
  allow_cortesy?: string;
  allow_discount?: string;
  sign_in_type?: string;
  have_password?: string;
  description?: string;
  unique_product?: string;
  check_tickets?: string;
}

interface IGame {
  reference?: string;
  points?: number;
  id?: number;
}

interface ConfigurationContextData {

  configuration: IConfiguration;
  setConfiguration(data: IConfiguration): void;
  projectHash: string;
  setProjectHash(data: string): void;
  eventHash: string;
  setEventHash(data: string): void;

}

const ConfigurationContext = createContext<ConfigurationContextData>({} as ConfigurationContextData);

const ConfigurationProvider: React.FC = ({ children }) => {
  const { socket } = useSocket();
  const { user, handleApiErrors } = useAuth();
  const { prepareMenu } = usePages();
  const [configuration, setConfiguration] = useState<Record<string, any>>({});
  const [projectHash, setProjectHash] = useState('');
  const [eventHash, setEventHash] = useState('');



  const load = async (projectHashValue) => {
    // setLoading(true);

    try {


      let data: Record<string, any> = {};

      const project = await loadFromJson({ hash: hash, project_id: projectHashValue, table: 'Project' });

      if (project?.[0]) {
        data = project[0];

        const event = await loadFromJson({ hash: hash, project_id: data.url, table: 'Event' });
        if (event?.[0]) {


          data.current_event_id_response = { ...event[0] };
        }
        else {

          const response = await api.get(eventHash ? `/get-project-content/${projectHashValue}/${eventHash}` : `/get-project-content/${projectHashValue}`);
          data = response?.data;
        }
      }
      else {

        const response = await api.get(eventHash ? `/get-project-content/${projectHashValue}/${eventHash}` : `/get-project-content/${projectHashValue}`);

        data = response?.data;
      }

      data.sign_in_type = 'cpf';

      setConfiguration(data);



      if (data?.active_pages?.length > 0) {

        prepareMenu({ eventHash, projectHash: projectHashValue, active_pages: data?.active_pages });
      }


      //setTimeout(() => { removeLoading('loading'); }, 1000)
    }
    catch (err) {

      handleApiErrors(err);

      //  setTimeout(() => { removeLoading('loading'); }, 1000)

    }
  }

  useEffect(() => {

    load(projectHash);
  }, [projectHash, eventHash])

  return (
    <ConfigurationContext.Provider
      value={{
        configuration,
        setConfiguration,
        eventHash,
        setEventHash,
        projectHash,
        setProjectHash

      }}
    >
      {children}
    </ConfigurationContext.Provider>
  );
};

function useConfiguration(): ConfigurationContextData {
  const context = useContext(ConfigurationContext);

  if (!context) {
    throw new Error('useConfiguration must be used within an ConfigurationProvider');
  }

  return context;
}

export { ConfigurationProvider, useConfiguration };
